import React from "react";
import PropTypes from "prop-types";
import OsmosisDataSkeleton from "./OsmosisDataSkeleton";

const formatCap = (capNumber) => {
  return capNumber.toLocaleString("en-US", { maximumFractionDigits: 0 });
};

const StatCard = ({ icon, title, value, overlayIcon }) => (
  <div className="p-4 bg-white shadow rounded-lg flex items-center justify-center">
    <div>
      <h3 className="text-lg sm:text-xl font-semibold text-gray-600 whitespace-nowrap relative flex flex-items">
        {overlayIcon && (
          <img
            src={overlayIcon}
            alt=""
            className="absolute w-6 h-6 transform translate-x-1/2"
            style={{ zIndex: 0 }}
          />
        )}
        <img
          src={icon}
          alt={title}
          className={`w-6 h-6 ${overlayIcon ? "relative mr-5" : "mr-2"}`}
          style={{ zIndex: 1 }}
        />
        {title}
      </h3>
      <p className="text-xl sm:text-2xl font-bold text-gray-800">{value}</p>
    </div>
  </div>
);

const OsmosisData = ({ osmosisPoolData }) => {
  if (!osmosisPoolData) {
    return <OsmosisDataSkeleton />;
  }

  return (
    <div className="mb-8">
      <h3 className="text-2xl font-semibold mb-4">Osmosis Pool 1721</h3>
      <div className="mb-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
        <StatCard
          icon="/icons/wlibra.svg"
          title="Pooled wLibra"
          value={formatCap(osmosisPoolData.wLibraAmount)}
        />
        <StatCard
          icon="/icons/usdc.png"
          title="Pooled USDC"
          value={`$${formatCap(osmosisPoolData.usdcAmount)}`}
        />
        <StatCard
          icon="/icons/wlibra.svg"
          title="Liquidity"
          value={`$${formatCap(osmosisPoolData.liquidity)}`}
          overlayIcon="/icons/usdc.png"
        />
      </div>
    </div>
  );
};

OsmosisData.propTypes = {
  osmosisPoolData: PropTypes.object.isRequired,
};

export default OsmosisData;
